module.exports = __webpack_public_path__ + "img/btn-btn-my-right-p.f0d695ef.svg";